import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  inject,
  Input,
  ChangeDetectorRef,
  SimpleChanges,
  OnChanges,
  viewChild,
} from "@angular/core";
import { CourseParticipantsDialogComponent } from "../../Dialogs/course-participants-dialog/course-participants-dialog.component";
import {
  Course,
  CourseParticipant,
  CourseCategory,
  CourseEvent,
  CourseProgressNameType,
  CourseProgressTranslations,
} from "TrainingTrackingDataTypes";
import { Department, InternalTitle } from "BaseDataTypes";

import { FormsModule } from "@angular/forms";
import { CourseService } from "TrainingTrackingServices/course-service";
import { DepartmentService } from "TrainingTrackingServices/department-service";
import { InternalTitleService } from "TrainingTrackingServices/internal-titles-service";
import { CourseEventLogService } from "TrainingTrackingServices/course-event-log-service";
import { User, LogDTO, LogType } from "BaseDataTypes";
import { UserService } from "BaseServices/user-service";
import { CourseCategoryService } from "TrainingTrackingServices/course-categories-service";
import { CourseParticipantsService } from "TrainingTrackingServices/course-participants-service";
import { MatDialog } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import {
  ListViewComponent,
  listRow,
  AutoDropdownComponent,
  getExtraBurgerMenuOptions,
  MenuOption,
} from "@standard-angular-utilities/shared-components";
import { MatIconModule } from "@angular/material/icon";
import { SharedFunctionsService } from "BaseServices/sharedFunctions.service";
import { LogService } from "BaseServices/log-service";
import { LogHelperService } from "BaseServices/log-helper.service";
import {
  BaseListPageComponent,
  FilterList,
} from "src/app/BasePages/base-list-page/base-list-page.component";
import { forkJoin } from "rxjs";
@Component({
  selector: "app-course-view",
  templateUrl: "./course-participants-view.component.html",
  styleUrls: ["./course-participants-view.component.css"],
  imports: [FormsModule, MatButtonModule, MatIconModule, BaseListPageComponent],
})
export class CourseParticipantsViewComponent implements OnInit, AfterViewInit {
  @ViewChild("baseListPage")
  baseListPage!: BaseListPageComponent<CourseParticipant>;
  @ViewChild("userFilterDropdown") userFilterDropdown:
    | HTMLSelectElement
    | undefined;

  readonly dialog = inject(MatDialog);

  onChangeFunction: () => void = () => {};

  currentUserHeaderList: string[] = [];
  courseParticipantHeaderList: string[] = [
    "Deltager",
    "Intern titel",
    "Afdeling",
    "Nærmeste leder",
    "Kursus",
    "Kursuskategori",
    "Status",
    "Dato",
    "Kursusbevis",
    "Kursusbeskrivelse",
    "Kursuslink",
  ];
  headersTextList: string[] = this.courseParticipantHeaderList;

  logHeaderList: string[];
  users: User[] = [];
  courses: Course[] = [];
  departments: Department[] = [];
  internalTitles: InternalTitle[] = [];
  courseParticipants: CourseParticipant[] = [];
  courseCategories: CourseCategory[] = [];
  nearestManagers: User[] = [];
  currentUser = this.userService.currentUser;
  courseProgressNames: {
    value: CourseProgressNameType;
    name: string;
    id: number;
  }[] = [];

  previousList: listRow<CourseParticipant>[] | undefined;
  previousHeaderList: boolean[] | undefined;

  filterLists: FilterList[] = [];

  constructor(
    private courseParticipantsService: CourseParticipantsService,
    private courseService: CourseService,
    private courseCategoryService: CourseCategoryService,
    private courseEventLogService: CourseEventLogService,
    private departmentService: DepartmentService,
    private internalTitleService: InternalTitleService,
    public userService: UserService,
    private sharedFunctionsService: SharedFunctionsService,
    private logService: LogService,
    private logHelper: LogHelperService
  ) {
    this.logHeaderList = this.logService.getLogHeaders("Kursusdeltager");
  }

  updateFilterLists() {
    var list = [];

    var userFilter: FilterList = {
      selectedValue: 0,
      items: this.users,
      displayProperty: "name",
      label: "Søg Deltager",
      filterFunction: function (courseParticipant: CourseParticipant) {
        return (
          this.selectedValue === 0 ||
          courseParticipant.userId == this.selectedValue
        );
      },
    };
    list.push(userFilter);

    var courseFilter: FilterList = {
      selectedValue: 0,
      items: this.courses,
      displayProperty: "name",
      label: "Søg Kursus",
      filterFunction: function (courseParticipant: CourseParticipant) {
        return (
          this.selectedValue === 0 ||
          courseParticipant.courseId == this.selectedValue
        );
      },
    };
    list.push(courseFilter);
    var categoryFilter: FilterList = {
      selectedValue: 0,
      items: this.courseCategories,
      displayProperty: "name",
      label: "Søg Kursuskategori",
      filterFunction: function (courseParticipant: CourseParticipant) {
        return (
          this.selectedValue === 0 ||
          courseParticipant.course?.courseCategoryId == this.selectedValue
        );
      },
    };
    list.push(categoryFilter);
    var statusFilter: FilterList = {
      selectedValue: 0,
      items: this.courseProgressNames,
      displayProperty: "name",
      label: "Søg Status",
      filterFunction: function (courseParticipant: CourseParticipant) {
        return (
          this.selectedValue === 0 ||
          Object.keys(CourseProgressNameType).indexOf(
            courseParticipant.courseProgresses[0].courseProgressName
          ) +
            1 ==
            this.selectedValue
        );
      },
    };
    list.push(statusFilter);
    var managerFilter: FilterList = {
      selectedValue: 0,
      items: this.nearestManagers,
      displayProperty: "name",
      label: "Søg Nærmeste leder",
      filterFunction: function (courseParticipant: CourseParticipant) {
        return (
          this.selectedValue === 0 ||
          courseParticipant.user?.nearestManagerId == this.selectedValue
        );
      },
    };
    list.push(managerFilter);
    var departmentFilter: FilterList = {
      selectedValue: 0,
      items: this.departments,
      displayProperty: "displayName",
      label: "Søg Afdeling",
      filterFunction: function (courseParticipant: CourseParticipant) {
        return (
          this.selectedValue === 0 ||
          courseParticipant.user?.departmentId == this.selectedValue
        );
      },
    };
    list.push(departmentFilter);

    var internalTitleFilter: FilterList = {
      selectedValue: 0,
      items: this.internalTitles,
      displayProperty: "name",
      label: "Søg Intern titel",
      filterFunction: function (courseParticipant: CourseParticipant) {
        return (
          this.selectedValue === 0 ||
          courseParticipant.user?.internalTitleId == this.selectedValue
        );
      },
    };
    list.push(internalTitleFilter);
    this.filterLists = list;
  }
  /**
   * Sets the default headers for users, based on roles
   */
  setDefaultHeadersForUserRole() {
    var hiddenHeaders = ["Kursusbeskrivelse", "Kursuslink"];

    // If the user role is User, we hide more headers by default
    if (
      this.userService.getSelectedRole == this.userService.getUserRoleTypes.User
    ) {
      hiddenHeaders.push(
        ...["Deltager", "Intern titel", "Afdeling", "Nærmeste leder"]
      );
    }
    this.baseListPage.setDefaultHeaders(hiddenHeaders);
  }

  /**
   * Function which creates a defaultParticipant, and opens it in the dialog
   */
  createNewCourseParticipant = () => {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    let defaultParticipant: CourseParticipant = {
      id: 0,
      userId: 0,
      courseId: 0,
      courseProgresses: [
        {
          id: 0,
          courseParticipantId: 0,
          courseProgressName: CourseProgressNameType.Enrolled,
          statusDateTime: today,
          deadline: today,
          completionDate: today,
          enrollmentDate: today,
          expiryDate: today,
        },
      ],
    };
    this.openCourseParticipantDialog([defaultParticipant]);
  };

  /**
   * Function for opening the selected participants for mass edit
   */
  confirmSelected = (list: listRow<CourseParticipant>[]) => {
    var selectedParticipant: CourseParticipant[] = list.map((row) => row.object);
    this.openCourseParticipantDialog(selectedParticipant);
  };

  /**
   * Function for clicking participant in participants list, calls open dialog
   * @param participant
   */
  courseParticipantClicked(participant: CourseParticipant) {
    this.openCourseParticipantDialog([participant]);
  }

  /**
   * Function which opens CourseParticipantsDialogComponent with supplied participants list
   * @param participants
   * @returns
   */
  openCourseParticipantDialog(participants: CourseParticipant[]) {
    if (this.baseListPage.isHistory) {
      return;
    }
    let dialogref = this.dialog.open(CourseParticipantsDialogComponent, {
      data: { data: participants },
      disableClose: true,
    });
    dialogref.afterClosed().subscribe((result) => {
      if (result == true) {
        this.updateListWithCourseParticipants();
      }
    });
  }

  /**
   * get all users from backend
   */
  getUsers() {
    this.userService.getUsers().subscribe((result) => {
      this.users = result;
    });
  }

  /**
   * get all departments from backend
   */
  getDepartments() {
    this.departmentService.getDepartments().subscribe((result) => {
      this.departments = result;
    });
  }

  /**
   * get all internalTitles from backend
   */
  getInternalTitles() {
    this.internalTitleService.getInternalTitles().subscribe((result) => {
      this.internalTitles = result;
    });
  }

  /**
   * get courses from backend
   */
  getCourses() {
    this.courseService.getCourses().subscribe((result) => {
      this.courses = result;
    });
  }

  /**
   * get all course categories from backend
   */
  getCourseCategories() {
    this.courseCategoryService.getCourseCategories().subscribe((result) => {
      this.courseCategories = result;
    });
  }

  /**
   * get all managers from the database
   */
  getNearestManager() {
    this.userService.getNearestManagers().subscribe((result) => {
      this.nearestManagers = result;
    });
  }
  ngOnInit(): void {
    const isAdmin =
      this.userService.getSelectedRole ===
      this.userService.getUserRoleTypes.Admin;
    const customLabel = "Skift til kurser";

    this.courseProgressNames = Object.values(CourseProgressNameType).map(
      (value) => ({
        value: value,
        name: CourseProgressTranslations[value],
        id: Object.keys(CourseProgressNameType).indexOf(value) + 1,
      })
    );
  }
  ngAfterViewInit(): void {
    this.userService.userStatusChanged$.subscribe((value) => {
      forkJoin({
        users: this.userService.getUsers(),
        departments: this.departmentService.getDepartments(),
        internalTitles: this.internalTitleService.getInternalTitles(),
        courseCategories: this.courseCategoryService.getCourseCategories(),
        courses: this.courseService.getCourses(),
        nearestManagers: this.userService.getNearestManagers(),
      }).subscribe((result) => {
        this.users = result.users;
        this.departments = result.departments;
        this.internalTitles = result.internalTitles;
        this.courseCategories = result.courseCategories;
        this.courses = result.courses;
        this.nearestManagers = result.nearestManagers;

        this.updateFilterLists();
      });
      this.updateListWithCourseParticipants();
      this.setDefaultHeadersForUserRole();
    });
  }

  /**
   * Helper function for updateListWithEventlogData
   * @param id
   * @returns
   */
  getCourseCategoryName(id: number): string {
    return (
      this.courseCategories.find((category) => category.id === id)?.name ||
      "Kategori ikke fundet"
    );
  }

  /**
   * Helper function for updateListWithEventlogData
   * @param nearestManagerId
   * @returns
   */
  getManagerName(nearestManagerId: number): string {
    return (
      this.nearestManagers.find((user) => user.id === nearestManagerId)?.name ||
      "Leder ikke fundet"
    );
  }

  getUserNameFromCourseParticipantId(id: number): string {
    const input = this.courseParticipants.find(
      (courseParticipant) => courseParticipant.id === id
    )?.userId;
    const name = this.users.find((user) => user.id === input)?.name;

    return name || "Deltager ikke fundet";
  }

  /**
   * Helper function for updateListWithEventlogData
   * @param id
   * @returns Name by user id or "Bruger ikke fudet"
   */
  getUserNameFromUserId(id: number): string {
    return this.users.find((user) => user.id === id)?.name || id.toString();
  }

  /**
   * Function which switches the list between courses categories and the course category event log.
   */
  switchDataInList = (isHistory: boolean) => {
    if (isHistory) {
      this.updateListWithCourseParticipants();
    } else {
      this.updateListWithLogData();
    }
  };

  /**
   * Function to update list with eventlog data
   */
  updateListWithLogData() {
    this.logHelper.updateLogList(
      LogType.CourseParticipant,
      this.getUserNameFromUserId.bind(this),
      (data) => this.baseListPage.UpdateLogListData(data)
    );
  }

  /**
   * Function to update list with course participants data
   */
  updateListWithCourseParticipants = () => {
    this.courseParticipantsService.getParticipants().subscribe((result) => {
      let tempList: listRow<CourseParticipant>[] = [];
      //Generate list of participants based on users rights
      result.forEach((courseParticipant) => {
        if (
          courseParticipant.user == null ||
          courseParticipant.course == null ||
          this.sharedFunctionsService.isNullOrEmpty(
            courseParticipant.courseProgresses
          )
        ) {
          return; //return from forEach loop if partipant got no user or course (sanity check)
        }
        //User can view participant if
        //user is role 1 (administrator)
        //participant is user
        //user is role 2 (nearestLeader) and participant's nearestLeader
        //role 6 is enrollmentManager
        if (
          courseParticipant.courseProgresses != undefined &&
          courseParticipant.courseProgresses.length > 0 &&
          (this.userService.getSelectedRole ==
            this.userService.getUserRoleTypes.Admin ||
            courseParticipant.user.id == this.currentUser?.id ||
            courseParticipant.user.nearestManagerId == this.currentUser?.id)
        ) {
          let courseProgress = courseParticipant.courseProgresses![0];
          let basicData = [
            courseParticipant.user.name,
            courseParticipant.user.internalTitle?.name
              ? courseParticipant.user.internalTitle?.name
              : "",
            courseParticipant.user.department?.displayName
              ? courseParticipant.user.department?.displayName
              : "",
            this.getManagerName(courseParticipant.user.nearestManagerId),
            courseParticipant.course.name,
            this.getCourseCategoryName(
              courseParticipant.course.courseCategoryId
            ),
            CourseProgressTranslations[
              courseProgress.courseProgressName as unknown as keyof typeof CourseProgressNameType
            ],
            new Date(courseProgress.statusDateTime),
            courseProgress.certificateContentType ? "Ja" : "Nej",
            courseParticipant.course.description || "",
            courseParticipant.course.courseLink || "",
          ];
          tempList.push({
            object: courseParticipant,
            id: courseParticipant.id,
            data: basicData,
          });
        }
      });

      this.courseParticipants = result;
      this.headersTextList = this.courseParticipantHeaderList;
      this.baseListPage.UpdateListData(tempList);
    });
  };
}
